<template lang="pug">
  .d-flex.align-center.pa-4.neutral300
    v-icon.mr-4(color="neutral700") $yzi-markerpin-02
    .text-lg {{ companyName }}
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    companyName() {
      return this.company?.name
    }
  },
}
</script>

<style scoped>
</style>